import { http } from "@/http/axios.js";

// 法诉状态导入
export function importLegalStatusAPI(data) {
  return http({
    url: "/admin/afterSaleOrder/law/status/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 债转状态导入
export function importDebtTransferStatusAPI(data) {
  return http({
    url: "/admin/afterSaleOrder/debt/status/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

